module.exports = __webpack_public_path__ + "static/fipclemonbrave3-a5cc364afa981c386e53915482892cb4.jpeg";